export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  FilterValue: { input: any; output: any; }
};

export enum ContactType {
  Callback = 'CALLBACK',
  Email = 'EMAIL',
  NotSet = 'NOT_SET',
  Redirect = 'REDIRECT'
}

export type Filter = {
  name: Scalars['String']['input'];
  operator: FilterOperator;
  value: Scalars['FilterValue']['input'];
};

export enum FilterOperator {
  And = 'and',
  At = 'at',
  /**
   * Will transform `FilterValue` to a regex. Special characters will not be escaped.
   *
   * Example:
   * ```
   * const data = [
   *   "a",
   *   "abc",
   *   "abd",
   *   "ccd"
   * ]
   *
   * const filter = {
   *   value: "a",
   *   operator: "contains"
   * }
   *
   * -> ["a", "abc", "abd"]
   *
   * const filter = {
   *   value: "a",
   *   operator: "equals"
   * }
   *
   * -> ["a"]
   * ```
   *
   * If the Document value by which you want to filter is an array, the `FilterValue` has to match at least one of the values of the beforementioned array.
   */
  Contains = 'contains',
  Empty = 'empty',
  /** Document value must match FilterValue. If Document value is an Array, the Array needs to include the FilterValue */
  Equals = 'equals',
  Gt = 'gt',
  Gte = 'gte',
  Lt = 'lt',
  Lte = 'lte',
  NotEmpty = 'notEmpty',
  Or = 'or'
}

export type Mutation = {
  __typename?: 'Mutation';
  saveProduct: Scalars['String']['output'];
};


export type MutationSaveProductArgs = {
  product: ProductInput;
};

export type Product = {
  __typename?: 'Product';
  /** Indicates if Product is available for purchase */
  active: Scalars['Boolean']['output'];
  /** Categories of Product */
  categories: Array<ProductCategory>;
  /** Available ways of initiating the contact */
  contactTypes: Array<ContactType>;
  /** ID of user that created Product */
  createdBy: User;
  /** Visibile description of Product */
  description: Scalars['String']['output'];
  /** List of visible primary features Product has to offer */
  features: Array<Scalars['String']['output']>;
  /** Available fields of law to choose from */
  fieldsOfLaw: Array<Scalars['String']['output']>;
  /** Date of Product being active the first time */
  firstActive?: Maybe<Scalars['Date']['output']>;
  /** uuid of Product */
  id: Scalars['String']['output'];
  /** Path to image of product */
  image: Scalars['String']['output'];
  /** Descriptive price of Product e.g. recommended retail price */
  labelPrice: Scalars['Float']['output'];
  /** Meta description */
  metaDescription: Scalars['String']['output'];
  /** Meta title */
  metaTitle: Scalars['String']['output'];
  /** Visible name of Product */
  name: Scalars['String']['output'];
  /** Netto price of Product */
  netto: Scalars['Float']['output'];
  /** id of parent Product */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Brutto price of Product */
  price: Scalars['Float']['output'];
  /** List of visible secondary features Product has to offer */
  secondaryFeatures: Array<Scalars['String']['output']>;
  /** List of services provided by the lawyer */
  services: Array<Scalars['String']['output']>;
  /** Visibile short description of Product used for billing */
  shortDescription: Scalars['String']['output'];
  /** URL part of Product */
  slug: Scalars['String']['output'];
  /** Descriptive subtitle of Product */
  subtitle: Scalars['String']['output'];
  /** Absolute tax amount */
  tax: Scalars['Float']['output'];
  /** Descriptive title of Product - Visible name of Product for customers */
  title: Scalars['String']['output'];
  /** Type of Product based on customer */
  type: ProductType;
  /** List of visible unique selling points Product has to offer */
  uniqueSellingPoints: Array<Scalars['String']['output']>;
  /** Product variants */
  variants: Array<Product>;
};

export enum ProductCategory {
  Featured = 'FEATURED',
  Festpreis = 'FESTPREIS',
  Frontpage = 'FRONTPAGE',
  Individual = 'INDIVIDUAL'
}

export type ProductInput = {
  /** Indicates if Product is available for purchase */
  active: Scalars['Boolean']['input'];
  /** Categories of Product */
  categories: Array<ProductCategory>;
  /** Available ways of initiating the contact */
  contactTypes: Array<ContactType>;
  /** Visibile description of Product */
  description: Scalars['String']['input'];
  /** List of visible primary features Product has to offer */
  features: Array<Scalars['String']['input']>;
  /** Available fields of law to choose from */
  fieldsOfLaw: Array<Scalars['String']['input']>;
  /** uuid of Product */
  id: Scalars['String']['input'];
  /** Path to image of product */
  image: Scalars['String']['input'];
  /** Descriptive price of Product e.g. recommended retail price */
  labelPrice: Scalars['Float']['input'];
  /** Meta description */
  metaDescription: Scalars['String']['input'];
  /** Meta title */
  metaTitle: Scalars['String']['input'];
  /** Name of Product */
  name: Scalars['String']['input'];
  /** Actual net price of Product */
  netto?: InputMaybe<Scalars['Float']['input']>;
  /** id of parent Product */
  parentId?: InputMaybe<Scalars['String']['input']>;
  /** Actual pre-tax price of Product */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** List of visible secondary features Product has to offer */
  secondaryFeatures: Array<Scalars['String']['input']>;
  /** List of services provided by the lawyer */
  services: Array<Scalars['String']['input']>;
  /** Visibile short description of Product used for billing */
  shortDescription: Scalars['String']['input'];
  /** URL part of Product */
  slug: Scalars['String']['input'];
  /** Descriptive subtitle of Product */
  subtitle: Scalars['String']['input'];
  /** Descriptive title of Product - Visible name of Product for customers */
  title: Scalars['String']['input'];
  /** Type of Product based on customer */
  type: ProductType;
  /** List of visible unique selling points Product has to offer */
  uniqueSellingPoints: Array<Scalars['String']['input']>;
};

export enum ProductType {
  Business = 'BUSINESS',
  Consumer = 'CONSUMER'
}

export type ProductsList = {
  __typename?: 'ProductsList';
  list: Array<Product>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Check if single Product is available based on id */
  isProductIdAvailable: Scalars['Boolean']['output'];
  /** Return a single Product based on id */
  product: Product;
  /** Return a paginated list of Products */
  products: ProductsList;
};


export type QueryIsProductIdAvailableArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductArgs = {
  id: Scalars['String']['input'];
};


export type QueryProductsArgs = {
  filters?: InputMaybe<Array<Filter>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
};

export type Sort = {
  /** Name of a sortable field */
  sortBy: Scalars['String']['input'];
  /** Sorting direction. Either ascending or descending */
  sortDirection: SortDirection;
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type User = {
  __typename?: 'User';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type IsProductIdAvailableQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type IsProductIdAvailableQuery = { __typename?: 'Query', isProductIdAvailable: boolean };

export type ProductQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ProductQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, parentId?: string | null, name: string, type: ProductType, title: string, subtitle: string, slug: string, contactTypes: Array<ContactType>, labelPrice: number, price: number, netto: number, tax: number, active: boolean, firstActive?: any | null, fieldsOfLaw: Array<string>, features: Array<string>, secondaryFeatures: Array<string>, uniqueSellingPoints: Array<string>, description: string, shortDescription: string, categories: Array<ProductCategory>, services: Array<string>, image: string, metaDescription: string, metaTitle: string, createdBy: { __typename?: 'User', id: string, name: string }, variants: Array<{ __typename?: 'Product', id: string, parentId?: string | null, name: string, type: ProductType, title: string, subtitle: string, slug: string, contactTypes: Array<ContactType>, labelPrice: number, price: number, netto: number, tax: number, active: boolean, firstActive?: any | null, fieldsOfLaw: Array<string>, features: Array<string>, secondaryFeatures: Array<string>, uniqueSellingPoints: Array<string>, description: string, shortDescription: string, categories: Array<ProductCategory>, services: Array<string>, image: string, metaDescription: string, metaTitle: string, createdBy: { __typename?: 'User', id: string, name: string } }> } };

export type SaveProductMutationVariables = Exact<{
  product: ProductInput;
}>;


export type SaveProductMutation = { __typename?: 'Mutation', saveProduct: string };
